const api_url = process.env.REACT_APP_API_URL
const shop_api_url = process.env.REACT_APP_SHOP_API_URL

export const getuserdetails = `${api_url}/user/userProfile`
export const login = `${api_url}/user/login`
export const getplayerdata = `${api_url}/player/showPlayerData`
export const uploadImageFile = `${api_url}/shop/uploadMultiShopImage`




export const createShopProfile = `${shop_api_url}/shopProfile/create-shopProfile`
export const getShopProfile = `${shop_api_url}/shopProfile/get-shopProfile`
export const getShopDashboard = `${shop_api_url}/shopProfile/get-shop-dashboard-details`
export const getAllCategory = `${shop_api_url}/category/get-category`
export const getAllGender = `${shop_api_url}/gender/get-gender`
export const getAllColors = `${shop_api_url}/color/get-color`
export const getAllSizes = `${shop_api_url}/size/get-size`
export const getAllProducts = `${shop_api_url}/product/get-product`
export const createProducts = `${shop_api_url}/product/create-product`
export const updateProducts = `${shop_api_url}/product/update-product`
export const createProductImages = `${shop_api_url}/media/create-media`
export const deleteProductImages = `${shop_api_url}/media/delete-media`
export const deleteProducts = `${shop_api_url}/product/delete-product`
export const createVarient = `${shop_api_url}/variant/create-variant`
export const updateVarient = `${shop_api_url}/variant/update-variant`
export const deleteVarient = `${shop_api_url}/variant/delet-variant`
export const createVarientImages = `${shop_api_url}/image/create-image`
export const deleteVarientImages = `${shop_api_url}/image/delete-image`
export const getVenderProducts = `${shop_api_url}/product/get-vendor-products`
export const getNewArrivals = `${shop_api_url}/product/get-new-arrivals`
export const getBanners = `${shop_api_url}/banner/get-banner`


export const createWishlist = `${shop_api_url}/wishlist/create-wishlist`
export const getWishlist = `${shop_api_url}/wishlist/get-wishlist`
export const removeWishlist = `${shop_api_url}/wishlist/remove-from-wishlist`


export const addtoCart = `${shop_api_url}/cart/add-to-cart`
export const getCart = `${shop_api_url}/cart/get-cart`
export const updateCartItem = `${shop_api_url}/cart/update-cartItem`
export const deleteCartItem = `${shop_api_url}/cart/remove-cartItem`


export const addAddress = `${shop_api_url}/address/create-shipping-address`
export const getAddress = `${shop_api_url}/address/get-address`
export const updateAddress = `${shop_api_url}/address/update-address`
export const deleteAddress = `${shop_api_url}/address/remove-address`


export const createOrder = `${shop_api_url}/order/create-order`
export const getOrder = `${shop_api_url}/order/get-orders`
export const getOrderbyId = `${shop_api_url}/order/get-order-by-id`
// export const updateOrder = `${shop_api_url}/address/update-address`
// export const deleteOrder = `${shop_api_url}/address/remove-address`







